//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'

import { BUILDING_STATUS } from '@/constant'
import ImgWrap from '@/components/business/img_wrap'
import type_name from '@/components/mixins/building_ranking'
import common_utils from './_house_item_utils.js'

const isArrayEmpty = function(item) {
    return !item || item.constructor !== Array || item.length === 0
}

export default {
    mixins: [
        type_name,
        common_utils
    ],
    computed: {
        hide_date () {
            const { date_with_status } = this.item || {}
            return !date_with_status || (this.type === '即将预售' && date_with_status.indexOf('摇号时间') > -1)
        },
        center() {
            return isArrayEmpty(this.item.customized_price) && isArrayEmpty(this.item.price_desc_arr) && !this.item.building_ranking
            || isArrayEmpty(this.item.tags) && !this.item.building_ranking
        }
    },
    methods: {
        goDetail (e) {
            if (this.just_view) {
                return
            }
            const { log_id, href, position } = this.item
            const url = `${href}&status=${BUILDING_STATUS[this.type] || ''}`
            this.$router.push({
                path: url
            })
            if (log_id) {
                Service.interestingEvent({
                    interesting_id: log_id,
                    event: 'click',
                    pos_name: position,
                    pos: this.index || 0
                })
            }
        },
        goComments (e) {
            if (this.just_view) {
                return
            }
            this.$router.push({
                path: this.item.comment_href
            })
        }
    },
    components: {
       ImgWrap
    },
    props: {
        item: {
            type: Object,
            default: {}
        },
        type: {
            type: String
        },
        index: {
            type: [String, Number]
        },
        classname: {
            type: String,
            default: ''
        },
        is_hot: {
            type: Boolean,
            default: false
        },
        just_view: Boolean
    }
}
